const styles = (theme) => ({
  buttomAddUser: {
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
    maxWidth: "200px",
    "@media (max-width: 1350px)": {
      maxWidth: "200px",
    },
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  searcField: {
    width: "100%",
    maxWidth: 500,
    display: "flex",
    fontSize: "0.75rem", // diminui fonte geral

    "@media (max-width: 1349px)": {
      width: "100%",
    },
  },
  clientAutocomplete: {
    width: "100%",
    maxWidth: 500,

    "@media (max-width: 1349px)": {
      width: "100%",
    },
    fontSize: "0.75rem", // diminui fonte geral
  },
});

export default styles;
